import supports from '../lib/supports.js';
import {gsap} from 'gsap';
import {reducedDuration} from '../lib/reduced-motion.js';

const setupObserver = (element) => {
  const observer = new IntersectionObserver(([e]) => {
    if (e.isIntersecting) {
      gsap.to('.section-nav-sticky-button.is-fixed', {
        duration: reducedDuration(0.3),
        y: '-100%',
      });
      gsap.to('.site-header', {
        duration: reducedDuration(0.3),
        y: 0,
      });
    } else if (e.intersectionRatio < 1) {
      if (e.boundingClientRect.top < e.intersectionRect.top) {
        gsap.to('.section-nav-sticky-button.is-fixed', {
          duration: reducedDuration(0.3),
          y: 0,
        });
        gsap.to('.site-header', {
          duration: reducedDuration(0.3),
          y: '-100%',
        });
      } else {
        gsap.to('.section-nav-sticky-button.is-fixed', {
          duration: reducedDuration(0.3),
          y: '-100%',
        });
        gsap.to('.site-header', {
          duration: reducedDuration(0.3),
          y: 0,
        });
      }
    }
  });

  observer.observe(element);
};

const cloneNav = (element) => {
  const subNav = element.querySelector('[data-element="section-nav-sticky-button"]');
  const subNavClone = subNav.cloneNode(true);

  const fixedNav = document.createElement('div');
  fixedNav.classList.add('section-nav-sticky-button', 'bg-midnight', 'is-fixed');

  fixedNav.append(subNavClone);
  document.body.append(fixedNav);
};

const sectionNavStickyButton = {
  init() {
    const element = document.querySelector('[data-module="sticky-nav-sticky-button"]');

    if (element && supports.intersectionObserver) {
      setupObserver(element);
      cloneNav(element);
    }
  },
};

export default sectionNavStickyButton;
